export default {
  tryAgain: "Volver a intentar",
  goHome: "Ir al inicio",
  loading: "Cargando…",
  send: "Enviar",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  optional: "Opcional",
  edit: "Editar",
  back: "Atrás",
  refresh: "Actualizar",
  confirm: "Confirmar",
  close: "Cerrar",
  add: "Añadir",
  copy: "Copiar",
  copySerial: "Copiar serie",
  copied: "¡Copiado!",
  clickToCopy: "Clic para copiar",
  clickToCopyValue: "Copiar {{value}}",
  copyFailed: "No se pudo copiar al portapapeles",
  search: "Buscar",
  clearSearch: "Borrar búsqueda",
  quickSearch: {
    title: "Búsqueda rápida",
    placeholder: "Ir a una página…",
    empty: "Ninguna página coincide",
    hint: "↑↓ para navegar · Enter para abrir · Esc para cerrar",
  },
  inactive: "Inactivo",
  user: "Usuario",
  privacyPolicy: "Política de privacidad",
  cookiePolicy: "Política de cookies",
  cookiePreferences: "Preferencias de cookies",
  privacyAndCookies: "Privacidad y cookies",
  privacyPolicyOpening: "Abriendo la política de privacidad…",
  backToDashboard: "Volver al panel",
  backToLogin: "Volver al inicio de sesión",
  copyright: "© {{year}} Flitrip. Todos los derechos reservados.",
  language: {
    label: "Idioma",
  },
  greeting: {
    morning: "Buenos días",
    afternoon: "Buenas tardes",
    evening: "Buenas noches",
  },
  errorOccurred: "Ha ocurrido un error",
  somethingWentWrong: "Algo ha salido mal. Inténtelo de nuevo más tarde.",
  appCrashTitle: "Algo ha salido mal",
  appCrashMessage:
    "Inténtelo de nuevo para volver a cargar la pantalla sin salir de la aplicación. Si sigue fallando, actualice el navegador o vaya al inicio.",
  relative: {
    justNow: "Ahora mismo",
    minutesAgo: "hace {{count}} min",
    hoursAgo: "hace {{count}} h",
    daysAgo: "hace {{count}} d",
  },
  chat: {
    dayToday: "Hoy",
    dayYesterday: "Ayer",
  },
  fileSize: {
    bytes: "{{count}} B",
    kb: "{{size}} KB",
    mb: "{{size}} MB",
  },
  unsavedChanges: {
    navigationTitle: "Cambios sin guardar",
    navigationMessage:
      "Guarde o revierta los cambios antes de salir de esta página.",
  },
  sectionModified: "Modificado",
  saveBar: {
    unsaved: "Cambios sin guardar",
    allSaved: "Todo guardado",
    save: "Guardar cambios",
    saveDraft: "Guardar borrador",
    revert: "Revertir cambios",
    revertConfirmTitle: "¿Descartar cambios sin guardar?",
    revertConfirmMessage:
      "Se perderán los cambios. Esta acción no se puede deshacer.",
    revertConfirm: "Descartar cambios",
  },
  addressAutocomplete: {
    loading: "Buscando direcciones…",
    error: "No se pudieron cargar las sugerencias de dirección.",
    noStreetResults:
      "No se encontraron direcciones con calle. Siga escribiendo o elija una dirección completa de la lista.",
  },
  addressSearch: {
    label: "Dirección",
    placeholder: "Empiece a escribir para buscar una dirección…",
    editDetails: "Editar detalles de la dirección",
    detailFieldsError: "Revise los detalles de la dirección a continuación.",
    fieldRequired: "Este campo es obligatorio.",
  },
  addressValidation: {
    checking: "Comprobando dirección…",
    valid: "La dirección es válida",
    invalid:
      "No se pudo localizar esta dirección. Revise los datos o elija otra dirección.",
    incomplete:
      "Complete todos los campos de la dirección para validar la ubicación.",
    saveConfirmTitle: "Dirección no válida",
    saveConfirmButton: "Guardar de todos modos",
    saveWarningActivity:
      "Esta dirección no es válida. Es posible que los clientes no vean esta actividad en la app porque requiere una ubicación geocodificada.",
    saveWarningHouse:
      "Esta dirección no es válida y puede no geocodificarse correctamente. Los servicios de ubicación de esta estructura pueden no funcionar.",
  },
  editableLocation: {
    noCoordinatesWarning:
      "Elija una dirección de la lista, escriba una dirección reconocible o haga clic en el mapa para fijar la ubicación.",
    mapHint:
      "Arrastre el marcador o haga clic en el mapa para ajustar la ubicación.",
    mapUnavailable:
      "Vista previa del mapa no disponible (mapa no configurado).",
    mapAriaLabel: "Mapa de ubicación editable",
  },
  map: {
    expand: "Expandir",
    expandedTitle: "Mapa",
    zoomHintCtrl: "Usa Ctrl + desplazamiento para hacer zoom en el mapa",
    zoomHintCmd: "Usa ⌘ + desplazamiento para hacer zoom en el mapa",
    panHintTouch: "Usa dos dedos para mover el mapa",
  },
  environmentBanner: {
    message:
      "Estás en el entorno {{environment}}. No es producción: los datos y los pagos son solo para pruebas.",
    messageShort: "Estás en {{environment}}",
    productionMessage:
      "Estás en producción. Estás usando datos reales y pagos reales — procede con precaución.",
    productionMessageShort: "Estás en producción",
    envNames: {
      development: "de desarrollo",
      staging: "de staging",
    },
    shortEnvNames: {
      development: "desarrollo",
      staging: "staging",
    },
  },
  region: {
    label: "Región de pago",
    empty: "No hay regiones disponibles",
    filterAll: "Todas las regiones",
    filterLabel: "Región",
    colCode: "Región",
    unknown: "—",
    names: {
      IT: "Italia",
      ES: "España",
    },
  },
  table: {
    paginationSummary: "Mostrando {{start}}-{{end}} de {{total}}",
    rowsPerPage: "Filas por página",
    previousPage: "Anterior",
    nextPage: "Siguiente",
    pageOf: "Página {{page}} de {{totalPages}}",
    resizeColumn: "Redimensionar columna",
    resizeColumnFor: "Redimensionar columna {{column}}",
    preferencesOpen: "Preferencias",
    preferencesTitle: "Preferencias de tabla",
    preferencesDescription: "Elige cuántas filas mostrar y qué columnas ver.",
    preferencesPageSize: "Filas por página",
    preferencesColumns: "Columnas",
    preferencesColumnsHint:
      "Arrastra para reordenar. Desmarca para ocultar una columna.",
    preferencesConfirm: "Confirmar",
    preferencesCancel: "Cancelar",
    preferencesReset: "Restablecer valores",
    reorderColumn: "Reordenar columna",
    selectRow: "Seleccionar fila",
    selectionColumn: "Selección",
    selectionHint: "Usa las casillas a la izquierda para seleccionar filas.",
    selectedCount: "{{count}} seleccionados",
    selectAllOnPage: "Seleccionar todos en la página",
    clearSelection: "Borrar selección",
  },
} as const;
